import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import AsSamplePreparationSection from 'Components/Worksheets/Shared/AS/Preparation/PreparationSection';
import ids from '../../QestIds';
import AsLiquidLimitOnePointSection from './LiquidLimit/OnePoint/LiquidLimitOnePointSection';
import { AsPlasticLimitSection } from './PlasticLimit';
import LinearShrinkageSection from './Sections/LinearShrinkageSection';
import ResultsSectionWithShrinkage from './Sections/ResultsSectionWithShrinkage';

const qestIds = [ids.atterbergLimit.AS_1289_3_1_2or3_2_1or3_3_1or3_4_1.rev2009];

let AsAtterbergLimitWorksheetOnePointWithShrinkage: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sample Preparation">
        <NamePrefixModifier appendNamePrefix="SamplePreparation">
          <AsSamplePreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Liquid Limit (One Point Casagrande)">
        <AsLiquidLimitOnePointSection />
      </PageSection>
      <AsPlasticLimitSection />
      <LinearShrinkageSection />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSectionWithShrinkage />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsAtterbergLimitWorksheetOnePointWithShrinkage.qestIds = qestIds;

export default AsAtterbergLimitWorksheetOnePointWithShrinkage;
